module.exports = __webpack_public_path__ + "img/011-boy-5.6ed02346.svg";